import {
	getSupplier,
	addSupplier,
	editSupplier,
	delSupplier,
	getyuanliao,
	getSupplierList,
	getSupplierDetail,
	addSupplierDetail,
	updateSupplierDetail,
	delSupplierDetail,
	updateSupplierList,
	getBuyer,
	changeSupplierStatus,
	addSavePurplan,
	addCommitPurplan,
	getPurplan,
	editSavePurplan,
	editCommitPurplan,
	delPurplan,
	getPurOrd,
	changePurOrdStatus,
	converCaipin,
	sendEmail,
	getPurnotice,
	getAllSupplier,
	getSupplierSingle,
	updateSupplierSingle,
	getInquiry,
	cancelInquiry,
	commitInquiry,
	delInquiry,
	purchaseImportInquiry,
	addInquiry,
	exportPurplan,
	getQuote,
	updateQuote,
	finalBidsQuery,
	finalBidsQueryButton,
	commitBidsQuery,
	getImportPurchase
} from '@/api/purchase'
// import { getCaigouyuanliaolist } from '@/api/stock'

const state = {}
const mutations = {}

const actions = {
	getSupplier ({}, data) {
		return new Promise((resolve, reject) => {
			getSupplier(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addSupplier ({}, data) {
		return new Promise((resolve, reject) => {
			addSupplier(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editSupplier ({}, data) {
		return new Promise((resolve, reject) => {
			editSupplier(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateSupplierList ({}, data) {
		return new Promise((resolve, reject) => {
			updateSupplierList(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delSupplierDetail ({}, data) {
		return new Promise((resolve, reject) => {
			delSupplierDetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateSupplierDetail ({}, data) {
		return new Promise((resolve, reject) => {
			updateSupplierDetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addSupplierDetail ({}, data) {
		return new Promise((resolve, reject) => {
			addSupplierDetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getyuanliao ({}, data) {
		return new Promise((resolve, reject) => {
			getyuanliao(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getSupplierDetail ({}, data) {
		return new Promise((resolve, reject) => {
			getSupplierDetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getSupplierList ({}, data) {
		return new Promise((resolve, reject) => {
			getSupplierList(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delSupplier ({}, data) {
		return new Promise((resolve, reject) => {
			delSupplier(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBuyer ({}, data) {
		return new Promise((resolve, reject) => {
			getBuyer(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	changeSupplierStatus ({}, data) {
		return new Promise((resolve, reject) => {
			changeSupplierStatus(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addSavePurplan ({}, data) {
		return new Promise((resolve, reject) => {
			addSavePurplan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addCommitPurplan ({}, data) {
		return new Promise((resolve, reject) => {
			addCommitPurplan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getPurplan ({}, data) {
		return new Promise((resolve, reject) => {
			getPurplan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editSavePurplan ({}, data) {
		return new Promise((resolve, reject) => {
			editSavePurplan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editCommitPurplan ({}, data) {
		return new Promise((resolve, reject) => {
			editCommitPurplan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delPurplan ({}, data) {
		return new Promise((resolve, reject) => {
			delPurplan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getPurOrd ({}, data) {
		return new Promise((resolve, reject) => {
			getPurOrd(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	changePurOrdStatus ({}, data) {
		return new Promise((resolve, reject) => {
			changePurOrdStatus(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	converCaipin ({}, data) {
		return new Promise((resolve, reject) => {
			converCaipin(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	sendEmail ({}, data) {
		return new Promise((resolve, reject) => {
			sendEmail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getPurnotice ({}, data) {
		return new Promise((resolve, reject) => {
			getPurnotice(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAllSupplier ({}, data) {
		return new Promise((resolve, reject) => {
			getAllSupplier(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getSupplierSingle ({}, data) {
		return new Promise((resolve, reject) => {
			getSupplierSingle(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateSupplierSingle ({}, data) {
		return new Promise((resolve, reject) => {
			updateSupplierSingle(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getInquiry ({}, data) {
		return new Promise((resolve, reject) => {
			getInquiry(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	cancelInquiry ({}, data) {
		return new Promise((resolve, reject) => {
			cancelInquiry(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	commitInquiry ({}, data) {
		return new Promise((resolve, reject) => {
			commitInquiry(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delInquiry ({}, data) {
		return new Promise((resolve, reject) => {
			delInquiry(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	purchaseImportInquiry ({}, data) {
		return new Promise((resolve, reject) => {
			purchaseImportInquiry(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addInquiry ({}, data) {
		return new Promise((resolve, reject) => {
			addInquiry(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	exportPurplan ({}, data) {
		return new Promise((resolve, reject) => {
			exportPurplan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getQuote ({}, data) {
		return new Promise((resolve, reject) => {
			getQuote(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	updateQuote ({}, data) {
		return new Promise((resolve, reject) => {
			updateQuote(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	finalBidsQuery ({}, data) {
		return new Promise((resolve, reject) => {
			finalBidsQuery(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	finalBidsQueryButton ({}, data) {
		return new Promise((resolve, reject) => {
			finalBidsQueryButton(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	commitBidsQuery ({}, data) {
		return new Promise((resolve, reject) => {
			commitBidsQuery(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getImportPurchase ({}, data) {
		return new Promise((resolve, reject) => {
			getImportPurchase(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
